import React from 'react'
import Icon from 'src/components/forms/icon/icon'
import GradientLink from 'src/components/projects/gradient_link/gradient_link'
import { CLASS_PREFIX } from 'src/constants'
import { COLOR_TYPE_WHITE } from 'src/utils/color'

import { textResources } from 'src/lang/de'
import './project_list_header.scss'

const cls = `${CLASS_PREFIX}project-list-header`

type Props = {
  openCreateProject?: () => void;
  openLearnMore: () => void;
};

const t = textResources.projects

export const ProjectListHeader: React.FC<Props> = ({
  openCreateProject,
  openLearnMore
}) => {
  return (
    <div className={`${cls}`}>
      {openCreateProject
        ? (
          <div className={`${cls}__mobile-cta`}>
            <button
              type="button"
              aria-label={t.overview.createProjectAria}
              onClick={openCreateProject}
            >
              <Icon name={'plus'} size={36} color={COLOR_TYPE_WHITE} />
            </button>
          </div>
        )
        : null}
      <div className={`${cls}__header-left`}>
        <h1 className={`${cls}__title`}>{t.overview.title}</h1>
        <p className={`${cls}__subtitle`}>{t.overview.subtitle}</p>
        <p className={`${cls}__scope`}>{t.overview.scope}</p>
        <GradientLink
          href="#"
          onClick={(e) => {
            e.preventDefault()
            openLearnMore()
          }}
        >
          {t.overview.learnMore}
        </GradientLink>
      </div>

      {openCreateProject
        ? (
          <button
            type="button"
            className={`${cls}__cta`}
            onClick={openCreateProject}
          >
            <Icon name={'plus'} size={18} color={COLOR_TYPE_WHITE} />
            <span className={`${cls}__cta-label`}>
              {t.overview.ctaHaveConcern}
            </span>
          </button>
        )
        : null}
    </div>
  )
}
